export const SCREEN_NAME = 'Marketplace';
export const MARKETPLACE_SCREEN_NAME_ONGOING = `${SCREEN_NAME}_ONGOING`;
